// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transition-wrapper {
  transition:
    opacity 300ms ease,
    transform 300ms ease;
  will-change: opacity, transform;
}

.transition-wrapper.slide-in {
  opacity: 1;
  transform: translateX(0);
}

.transition-wrapper.slide-out {
  opacity: 0;
  transform: translateX(-8px);
}
`, "",{"version":3,"sources":["webpack://./src/app/components/ui/Transition/Transition.css"],"names":[],"mappings":"AAAA;EACE;;wBAEsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B","sourcesContent":[".transition-wrapper {\n  transition:\n    opacity 300ms ease,\n    transform 300ms ease;\n  will-change: opacity, transform;\n}\n\n.transition-wrapper.slide-in {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.transition-wrapper.slide-out {\n  opacity: 0;\n  transform: translateX(-8px);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
